import React, { useEffect, useContext, useRef, useState } from "react";
import {
    Row,
    Col,
    Form,
    FormGroup,
    FormControl,
    Button,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { AppContext } from "../context/appContext";

import "./MessageForm.css";

const MessageForm = () => {
    const { socket, currentRoom, messages, setMessages, privateMemberMessage } =
        useContext(AppContext);
    const [message, setMessage] = useState("");
    const user = useSelector((state) => state.user);
    const messageEnd = useRef(null);
    useEffect(() => {
        scrollToBottom();
    }, [messages]);
    const scrollToBottom = () => {
        messageEnd.current.scrollIntoView({ behavior: "smooth" });
    };
    const getFormattedDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : "0" + month;
        let day = date.getDate().toString();
        day = day.length > 1 ? day : "0" + day;

        return month + "/" + day + "/" + year;
    };
    const todayDate = getFormattedDate();

    socket.off("room-messages").on("room-messages", (roomMessages) => {
        setMessages(roomMessages);
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!message) return;

        const today = new Date();
        const minutes =
            today.getMinutes() < 10
                ? "0" + today.getMinutes()
                : today.getMinutes();
        const time = today.getHours() + ":" + minutes;
        const roomId = currentRoom;
        socket.emit("message-room", roomId, message, user, time, todayDate);
        setMessage("");
    };

    return (
        <>
            <div className="message-output">
                {!user && (
                    <div className="alert alert-danger">
                        please Login/Register{" "}
                    </div>
                )}
                {user &&
                    messages.map(({ _id: date, messagesByDate }, indx) => (
                        <div key={indx}>
                            <p className="alert alert-info text-center message-date-indicator">
                                {date}
                            </p>
                            {messagesByDate?.map(
                                ({ content, time, from: sender }, msgInd) => (
                                    <div
                                        className={
                                            sender.email === user.email
                                                ? "message"
                                                : "incoming-message"
                                        }
                                        key={msgInd}
                                    >
                                        <div className="inner-message">
                                            <div className="sender-details">
                                                {" "}
                                                <img
                                                    style={{
                                                        marginLeft: "12px",
                                                        width: "30px",
                                                        height: "30px",
                                                        borderRadius: "50%",
                                                    }}
                                                    src={sender.picture}
                                                    alt=""
                                                />{" "}
                                                <span> {sender.name} </span>{" "}
                                            </div>
                                            <p className="message-line">
                                                {content}{" "}
                                                <span className="message-time">
                                                    {" "}
                                                    {time}{" "}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    ))}
                <div ref={messageEnd}></div>
            </div>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={11}>
                        <FormGroup>
                            <FormControl
                                type="text"
                                disabled={!user}
                                placeholder="enter your message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            ></FormControl>
                        </FormGroup>
                    </Col>
                    <Col md={1}>
                        <Button
                            disabled={!user}
                            type="submit"
                            variant="success"
                        >
                            <i
                                className="fa fa-paper-plane"
                                aria-hidden="true"
                            ></i>
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    );
};

export default MessageForm;
